import Box from '@mui/material/Box';
import Link from '@mui/material/Link';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import LaunchIcon from '@mui/icons-material/Launch';

// Local imports
import { pillStyles } from './CardComponent';

const FormLink = ({ link, text }) => {
    return (
        <Box sx={{ ...pillStyles, backgroundColor: '#fccd0f' }}>
            <DescriptionOutlinedIcon sx={{ mr: 1, verticalAlign: 'middle', color: 'black', fontSize: '2rem' }} />
            <Link 
                href={link} 
                target='_blank' 
                rel='noopener noreferrer' 
                sx={{ color: 'black', fontWeight: 600, fontSize: '1.1rem', verticalAlign: 'middle' }}
            >
                {text} 
                <LaunchIcon sx={{ fontSize: '1rem', ml: 0.5 }} />
            </Link>
        </Box>
    )
}

export default FormLink;